import React, { useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { useTranslation } from "react-i18next";

const BulkPicklistStringDialog = ({ onClose, onSave }) => {

    const { t } = useTranslation([
        "attribute/picklist_field",
    ]);

    const separators = [
        { name: t("space"), value: " " },
        { name: t("comma"), value: "," },
        { name: t("period"), value: "." },
        { name: t("colon"), value: ":" },
        { name: t("semicolon"), value: ";" },
        { name: t("dash"), value: "-" },
        { name: t("underscore"), value: "_" },
        { name: t("forward_slash"), value: "/" },
        { name: t("backslash"), value: "\\" },
        { name: t("pipe"), value: "|" },
        { name: t("tab"), value: "\t" },
        { name: t("newline"), value: "\n" },
        { name: t("carriage_return"), value: "\r" },
        { name: t("ampersand"), value: "&" },
        { name: t("equals"), value: "=" }
    ]

    const [picklistSeparator, setPicklistSeparator] = useState(separators[0]);
    const [picklistValues, setPicklistValues] = useState("");
    const [isDisabled, setIsDisabled] = useState(false);

    const savePicklistValues = async(e) => {
        e.preventDefault();
        setIsDisabled(true);
        const dropDownValues = processValues();
        await onSave(dropDownValues);
        onClose();
    }

    const processValues = () => {
        const dropDownValues = picklistValues.split(picklistSeparator.value);
        for (let i = 0; i < dropDownValues.length; i++) {
            dropDownValues[i] = dropDownValues[i].trim();
        }
        const uniqueValues = [...new Set(dropDownValues)];
        const nonEmptyValues = uniqueValues.filter(value => value !== "");
        return nonEmptyValues;
    }

    const itemRender = (li, itemProps) => {
        const itemChildren = (
            <span>
                {itemProps.dataItem.name} - " {itemProps.dataItem.value} "
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    const valueRender = (li, itemProps) => {
        const itemChildren = (
            <span>
                {itemProps.name} - " {itemProps.value} "
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    return (
        <Dialog
            width={400}
            height={380}
            title={t("add_bulk_dropdown_value_title")}
            onClose={onClose}>
            <form className="d-flex flex-column mt-2">
                <div className="col-12 mb-4">
                    <label className="mb-1">
                        {t("separator_label")}
                        <span>
                            <i className="fas fa-info-circle ms-1 text-primary" title={t("separator_information")} />
                        </span>
                    </label>
                    <DropDownList
                        data={separators}
                        itemRender={itemRender}
                        valueRender={valueRender}
                        value={picklistSeparator}
                        onChange={(e) => setPicklistSeparator(e.target.value)}
                    />
                </div>
                <div className="col-12 mb-3">
                    <label className="mb-2">
                        {t("values_label")}
                    </label>
                    <textarea
                        className="form-control"
                        value={picklistValues}
                        onChange={(e) => setPicklistValues(e.target.value)}
                        rows={8}
                    />
                </div>
                <DialogActionsBar layout="end">
                    <Button onClick={onClose} className="btn btn-secondary">
                        {t("cancel_button")}
                    </Button>
                    <Button onClick={savePicklistValues} className="btn btn-primary" disabled={isDisabled}>
                        {t("save_button")}
                    </Button>
                </DialogActionsBar>
            </form>
        </Dialog >
    );
}

export default BulkPicklistStringDialog;